import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../../components/general/Banner';
import Celikler from '../../components/general/Celikler';
import { fetchPageGetSlug } from '../../redux/slices/pageGetSlugSlice';
import { fetchSeoGet } from '../../redux/slices/seoGetSlice';

const ContractPage = () => {
    const page = useSelector((state) => state.pageGetSlug.data);
    const seo = useSelector((state) => state.seoGet.data);
    const [loading, setLoading] = useState(false);
    const lang = useSelector((state) => state.lang.lang);
    const dispatch = useDispatch();

    const getData = async () => {
        if (window.location.pathname.split('/')[1] !== null && window.location.pathname.split('/')[1] !== undefined) {
            setLoading(true)
            await dispatch(fetchPageGetSlug({ slug: window.location.pathname.split('/')[1] }));
            await dispatch(fetchSeoGet({ slug: window.location.pathname.split('/')[1] }));
            setLoading(false)
        }
    }

    useEffect(() => { getData() }, [])

    return (
        !loading ? <Celikler>
            {seo && seo.title && seo.description && (
                <Helmet>
                    <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
                    <meta name="description" content={seo.description?.[lang] || ""} />
                    <meta name="keywords" content={seo.keywords?.[lang] || ""} />
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
            )}
            <Banner title={page?.showcases[0]?.title[lang]} />
            <div className='contractContainer'>
                <div className='contractContainer2'>
                    <div dangerouslySetInnerHTML={{ __html: page?.showcases[0]?.content[lang] }}></div>
                </div>
            </div>
        </Celikler> : <div className="modern-spinner-wrapper">
            <div className="modern-spinner"></div>
        </div>
    )
}

export default ContractPage
